/** Date e etichette delle visite commerciali: sempre nel fuso Europe/Rome. */
export const VISITE_TZ = "Europe/Rome";

const HAS_ZONE = /(Z|[+-]\d{2}:?\d{2})$/i;

/** Valore per <input type="datetime-local"> (ora di Roma) da una data ISO del server. */
export function toRomeInput(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (!HAS_ZONE.test(raw)) return raw.slice(0, 16); // già ora locale (bozze vecchie / input)
  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) return "";
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat("en-GB", {
      timeZone: VISITE_TZ, year: "numeric", month: "2-digit", day: "2-digit",
      hour: "2-digit", minute: "2-digit", hourCycle: "h23",
    }).formatToParts(date).map((p) => [p.type, p.value])
  );
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
}

/** Testo leggibile in italiano, es. «20 ott 2026, 09:30». */
export function formatRome(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  const local = toRomeInput(raw);
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(local);
  if (!match) return "";
  const [, y, m, d, hh, mm] = match;
  const month = new Intl.DateTimeFormat("it-IT", { month: "short", timeZone: "UTC" }).format(new Date(Date.UTC(+y, +m - 1, 1)));
  return `${Number(d)} ${month.replace(".", "")} ${y}, ${hh}:${mm}`;
}

export const STATI_VISITA = {
  bozza: { label: "Bozza", className: "bg-amber-100 text-amber-900" },
  chiusa: { label: "Chiusa", className: "bg-emerald-100 text-emerald-900" },
  annullata: { label: "Annullata", className: "bg-slate-200 text-slate-700" },
};

export const ESITI_VISITA = {
  positiva: "Positiva",
  da_approfondire: "Da approfondire",
  negativa: "Negativa",
  nessun_esito: "Nessun esito",
};

export function statoLabel(stato) {
  return STATI_VISITA[stato]?.label || stato || "";
}

/** Riga di stato della card: niente «Intervista in corso» su visite chiuse o annullate. */
export function visitSummary(visit) {
  if (!visit) return "";
  if (visit.stato === "annullata") return visit.motivo_annullamento ? `Annullata: ${visit.motivo_annullamento}` : "Annullata";
  if (visit.stato === "chiusa") return visit.esito ? `Esito: ${ESITI_VISITA[visit.esito] || visit.esito}` : "Chiusa senza esito";
  return "Intervista in corso";
}
